import React from 'react';
import { Card, Avatar, Badge, Empty, Table, Tag } from 'antd';
import { CalendarOutlined } from '@ant-design/icons';
import moment from 'moment-jalaali';

const LeavesPersonalView = ({ data = null, loading = false }) => {
  const employee = data?.employee || null;
  const leavePeriod = data?.leave_period || null;
  const leaveQuotas = data?.leave_quotas || [];
  const totalAllowedLeaves = data?.total_allowed_leaves || 0;
  
  // محاسبه مجموع مرخصی‌های باقی‌مانده
  const totalRemaining = leaveQuotas.reduce((sum, quota) => sum + (quota.remaining || 0), 0);

  return (
    <div style={{ fontFamily: 'CustomFont' }}>
      {loading ? (
        <div className="text-center py-8 text-gray-500 dark:text-gray-400" style={{ fontFamily: 'CustomFont' }}>
          در حال بارگذاری...
        </div>
      ) : !data ? (
        <Empty
          description={<span style={{ fontFamily: 'CustomFont' }}>هیچ داده‌ای یافت نشد</span>}
          image={Empty.PRESENTED_IMAGE_SIMPLE}
        />
      ) : (
        <>
          {/* کارت‌های بالا */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
            {/* مرخصی‌های باقی‌مانده */}
            <Card className="bg-white dark:bg-gray-800">
              <div className="flex items-center gap-3">
                <div className="p-3 bg-gray-100 dark:bg-gray-700 rounded-lg">
                  <CalendarOutlined className="text-gray-600 dark:text-gray-400 text-xl" />
                </div>
                <div className="flex-1">
                  <div className="text-sm text-gray-500 dark:text-gray-400 mb-1" style={{ fontFamily: 'CustomFont' }}>
                    مرخصی‌های باقی‌مانده
                  </div>
                  <div className="flex items-center gap-2">
                    <Badge status="success" />
                    <span className="text-lg font-semibold text-gray-800 dark:text-gray-200" style={{ fontFamily: 'CustomFont' }}>
                      {totalRemaining} روز
                    </span>
                  </div>
                </div>
              </div>
            </Card>

            {/* اطلاعات کاربر */}
            <Card className="bg-white dark:bg-gray-800">
              <div className="flex items-center gap-4">
                <Avatar size={64} src={employee?.avatar} style={{ backgroundColor: '#1890ff' }}>
                  {employee?.name?.charAt(0) || '?'}
                </Avatar>
                <div>
                  <div className="text-lg font-semibold text-gray-800 dark:text-gray-200 mb-1" style={{ fontFamily: 'CustomFont' }}>
                    {employee?.name || '--'}
                  </div>
                  <div className="text-sm text-gray-500 dark:text-gray-400" style={{ fontFamily: 'CustomFont' }}>
                    {employee?.designation || '--'}
                  </div>
                  {employee?.department && (
                    <div className="text-xs text-gray-400 dark:text-gray-500 mt-1" style={{ fontFamily: 'CustomFont' }}>
                      {employee.department}
                    </div>
                  )}
                </div>
              </div>
            </Card>
          </div>

          {/* دوره مرخصی */}
          {leavePeriod && (
            <Card className="bg-white dark:bg-gray-800 mb-6">
              <div className="text-sm text-gray-600 dark:text-gray-400 mb-2" style={{ fontFamily: 'CustomFont' }}>
                دوره مرخصی
              </div>
              <div className="flex items-center gap-4" style={{ fontFamily: 'CustomFont' }}>
                <span className="text-gray-800 dark:text-gray-200">
                  از {moment(leavePeriod.start_date).format('jYYYY/jMM/jDD')} تا {moment(leavePeriod.end_date).format('jYYYY/jMM/jDD')}
                </span>
              </div>
            </Card>
          )}

          {/* سهمیه مرخصی */}
          <Card
            title={<span style={{ fontFamily: 'CustomFont' }}>سهمیه مرخصی</span>}
            className="bg-white dark:bg-gray-800"
          >
            <Table
              dataSource={leaveQuotas}
              rowKey={(record, idx) => record.leave_type_id || idx}
              pagination={false}
              style={{ fontFamily: 'CustomFont' }}
              locale={{
                emptyText: (
                  <Empty
                    description={<span style={{ fontFamily: 'CustomFont' }}>هیچ رکوردی یافت نشد</span>}
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                ),
              }}
              columns={[
                {
                  title: 'نوع مرخصی',
                  dataIndex: 'leave_type_name',
                  key: 'leave_type_name',
                  render: (text, record) => (
                    <div className="flex items-center gap-2">
                      {record.color && (
                        <div className="w-3 h-3 rounded-full flex-shrink-0" style={{ backgroundColor: record.color }} />
                      )}
                      <span className="font-medium">{text || '--'}</span>
                    </div>
                  ),
                },
                {
                  title: 'کل',
                  dataIndex: 'total',
                  key: 'total',
                  width: 100,
                  align: 'center',
                  render: (val) => <span>{val} روز</span>,
                },
                {
                  title: 'استفاده شده',
                  dataIndex: 'used',
                  key: 'used',
                  width: 120,
                  align: 'center',
                  render: (val) => <span>{val} روز</span>,
                },
                {
                  title: 'باقی‌مانده',
                  dataIndex: 'remaining',
                  key: 'remaining',
                  width: 120,
                  align: 'center',
                  render: (val) => (
                    <Tag color={val > 0 ? 'green' : 'red'} style={{ fontSize: 13, padding: '2px 10px' }}>
                      {val} روز
                    </Tag>
                  ),
                },
              ]}
            />
          </Card>
        </>
      )}
    </div>
  );
};

export default LeavesPersonalView;

